import { render, staticRenderFns } from "./InviteToUpsell.vue?vue&type=template&id=8263d49c"
import script from "./InviteToUpsell.vue?vue&type=script&lang=js"
export * from "./InviteToUpsell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports